import { useState } from "react";
import React from "react";

import {
  Box,
  Button,
  Column,
  Columns,
  Control,
  Field,
  Input,
  Section,
  SubTitle,
  Title,
} from "@allxsmith/bestax-bulma";

import Jobs from "./Jobs";
import Rentals from "./Rentals";
import Figures from "./Figures";
import { formatDate, getLastDayOfWeek, getFirstDayOfWeek, getFirstDayOfMonth, getLastDayOfMonth } from "../../utils";
import VehicleSales from "./VehicleSales";
import InfoModal from "./InfoModal";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useSelector} from "react-redux";
import {getDataFresh, getDepartmentsData} from "../../state/selectors";
import LoadingSpinner from "../Utils/Spinner";
import ContactSection from "./ContactSection";
import VehicleSection from "./VehicleSection";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import Nav from "../Nav/Nav";

function Home({ endpoint }) {
  const dataFresh = useSelector(getDataFresh);
  const [start, setStart] = useState(getFirstDayOfWeek(new Date()));
  const [infoModal, setInfoModal] = useState(false)
  const [end, setEnd] = useState(getLastDayOfWeek(start));
  const [view, setView] = useState('weekly');
  const [selectedDepartment, setSelectedDepartment] = useState(-1);


  const departmentsLoaded = useDepartmentsData({}, dataFresh);
  let departments = useSelector(getDepartmentsData);
  const onDateSelect = e => {
    view === 'weekly' ? onWeekSelect(e) : onMonthSelect(e)
  };

  const onViewChange = view => {
    setView(view);
    if (view === 'weekly') {
      setStart(getFirstDayOfWeek(start));
      setEnd(getLastDayOfWeek(start))
    } else if (view === 'monthly') {
      setStart(getFirstDayOfMonth(start));
      setEnd(getLastDayOfMonth(start))
    }
  };

  const onMonthSelect = e => {
    let first = getFirstDayOfMonth(new Date(e.target.value));
    let finish_date = getLastDayOfMonth(first);
    setStart(first);
    setEnd(finish_date);
  };

  const onWeekSelect = e => {
    let first = getFirstDayOfWeek(new Date(e.target.value));
    let finish_date = getLastDayOfWeek(first);
    setStart(first);
    setEnd(finish_date);
  };

  const onDepartmentChange = e => {
    setSelectedDepartment(e.target.value);
  }

  let dates = { start: formatDate(start), end: formatDate(end), type: view };

  if(!departmentsLoaded){
    return (
        <div>
          <Nav/>
          <LoadingSpinner/>
        </div>

    )
  }

  // document.title = process.env.REACT_APP_DOCUMENT_TITLE;

  return (
    <div>
      <Nav/>
      <br/>
      <br/>
      <Section>
        <Box>
          <Columns>
            <Column>
              <Title>Summary</Title>
            </Column>
          </Columns>
          <Columns>
            <Column>
              <SubTitle>
                {start.toDateString()} - {end.toDateString()}
              </SubTitle>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field className="has-addons">
                <Control>
                  <label className="label">Timeframe</label>
                  <Button
                    color={view === 'weekly' ? "primary" : ""}
                    onClick={() => onViewChange('weekly')}
                  >
                    Weekly
                  </Button>
                  <Button
                    color={view ==='monthly' ? "primary" : ""}
                    onClick={() => onViewChange('monthly')}
                  >
                    Monthly
                  </Button>
                </Control>
              </Field>
            </Column>
            <Column>
              <DepartmentSelector
                value={selectedDepartment}
                options={departments}
                onChange={onDepartmentChange}
                blank={true}
                label={"Department"}
              />
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <label className="label">Select a Date</label>
                <Field className="contact-section has-addons">
                  <Control>
                    <Input
                      type="date"
                      value={formatDate(start)}
                      name="day"
                      onChange={onDateSelect}
                    />
                  </Control>
                </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Button
                color={"info"}
                onClick={(e) => setInfoModal(true)}
              >
                Info
              </Button>
            </Column>
          </Columns>
        </Box>
        <Figures dates={dates} endpoint={endpoint} selectedDepartment={selectedDepartment}/>
        <Columns isMultiline>
          <Column>
            <ContactSection

            />
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Jobs />
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <VehicleSales dates={dates} endpoint={endpoint}/>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Rentals dates={dates} />
          </Column>
        </Columns>
        <VehicleSection
          endpoint={endpoint}
          dataFresh={dataFresh}
        />
        <InfoModal
          show={infoModal}
          setShow={setInfoModal}
        />
      </Section>
    </div>
  );
}
export default Home;
